// extracted by mini-css-extract-plugin
export default {"row":"tableRowDnD_row__gKfdz","td":"tableRowDnD_td__GveTX","cell":"tableRowDnD_cell__Fuid+"};